const DEFAULT_HEADER_BANNER_BACKGROUND = '#CAFFEB'
const DEFAULT_HEADER_BANNER_TEXT_COLOR = '#363A45'
const DEFAULT_HEADER_BANNER_CTA_PRIMARY_TEXT_COLOR = '#FFFFFF'
const DEFAULT_HEADER_BANNER_KIND: App.LabHeaderBannerResult['kind'] = 'promotional-primary'

export type TakeoverBannerLocation = 'search' | 'offer' | 'generic'

export const getTakeoverBannerLocation = (
  isSearchPage: boolean,
  isOfferPage: boolean,
): TakeoverBannerLocation => {
  if (isSearchPage) {
    return 'search'
  }
  if (isOfferPage) {
    return 'offer'
  }
  return 'generic'
}

export const getRenderableHeaderBanner = (
  headerBanners: App.LabHeaderBannersResult | undefined,
  dismissedIds: Set<string>,
): App.LabHeaderBannerResult | undefined => {
  if (!headerBanners?.banners?.length) {
    return undefined
  }

  const sorted = headerBanners.banners.slice().sort((a, b) => a.rank - b.rank)
  return sorted.find(banner => !dismissedIds.has(banner.id))
}

export const getHeaderBannerPresentation = (
  banner: App.LabHeaderBannerResult,
  isMobile: boolean,
): {
  kind: App.LabHeaderBannerResult['kind']
  isCustomAppearance: boolean
  description: string
  cta?: { label: string, path: string, style: 'primary' | 'secondary' | 'tertiary' }
  background: { mode: 'solid' | 'gradient', value: string } | { mode: 'image', imageId: string }
  textColor: string
  ctaPrimaryTextColor: string
  iconImageId?: string
} => {
  const description = isMobile && banner.description.mobile ? banner.description.mobile : banner.description.desktop
  const ctaItem = isMobile
    ? (banner.cta?.mobile ?? banner.cta?.desktop)
    : banner.cta?.desktop
  const cta = ctaItem
    ? {
        ...ctaItem,
        style: ctaItem.style ?? ((ctaItem as { outlined?: boolean }).outlined ? 'secondary' : 'tertiary'),
      }
    : undefined

  const textColor = banner.textColor || DEFAULT_HEADER_BANNER_TEXT_COLOR
  const ctaPrimaryTextColor = banner.ctaPrimaryTextColor || DEFAULT_HEADER_BANNER_CTA_PRIMARY_TEXT_COLOR

  const background = banner.background.mode === 'image'
    ? {
        mode: 'image' as const,
        imageId: banner.background.imageId,
      }
    : {
        mode: banner.background.mode,
        value: banner.background.value || DEFAULT_HEADER_BANNER_BACKGROUND,
      }

  return {
    kind: banner.kind || DEFAULT_HEADER_BANNER_KIND,
    isCustomAppearance: banner.isCustomAppearance ?? false,
    description,
    cta,
    background,
    textColor,
    ctaPrimaryTextColor,
    iconImageId: banner.iconImageId?.trim() || undefined,
  }
}
